import { linear, IEasingFunction } from '@/core/easing-functions.service';

class ScrollService {
    public scrollToTop() {
        window.scrollTo(0, 0);
    }

    public scrollToElement(element: HTMLElement, offset: number = 0, duration: number = 200, easingFunction: IEasingFunction = linear, scrollElement: HTMLElement | undefined = undefined) {
        duration === 0
            ? this.simpleScroll(element.offsetTop + offset, scrollElement)
            : this.animateScroll(element.offsetTop + offset, duration, easingFunction, scrollElement);
    }

    public simpleScroll(to: number, scrollElement: HTMLElement | undefined = undefined) {
        if (scrollElement) {
            scrollElement.scrollTop = to;
        } else {
            window.scrollTo(0, to);
        }
    }

    public smoothScroll(to: number, scrollElement: HTMLElement | undefined = undefined) {
        if (scrollElement) {
            scrollElement.scrollTop = to;
        } else {
            window.scrollTo({ top: to, behavior: 'smooth' });
        }
    }

    public animateScroll(to, duration, easingFunction: IEasingFunction = linear, scrollElement: HTMLElement | undefined = undefined) {
        const startingY = scrollElement ? scrollElement.scrollTop : window.pageYOffset;
        const diff = to - startingY;
        let start;
        window.requestAnimationFrame(function step(timestamp) {
            if (!start) {
                start = timestamp;
            }
            const time = timestamp - start;
            const percent = Math.min(time / duration, 1);

            const easedPercent = easingFunction(percent);

            if (scrollElement) {
                scrollElement.scrollTop = startingY + diff * easedPercent;
            } else {
                window.scrollTo(0, startingY + diff * easedPercent);
            }

            if (time < duration) {
                window.requestAnimationFrame(step);
            }
        });
    }
}

export default new ScrollService();
